import React, { Component } from "react";
import "../reportes/reporte.css";

class SolicitudReporteModal extends Component {

    formatoFecha = (fecha) => {
        if (!fecha) return "";
    
const meses = [
    "Ene", "Feb", "Mar", "Abr", "May", "Jun",
    "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"
];
    
        const partes = String(fecha).split("-");
        if (partes.length !== 3) return fecha;
    
        const [yyyy, mm, dd] = partes;
    
        const mesIndex = Number(mm) - 1;
        const mesTexto = meses[mesIndex];
    
        if (!mesTexto) return fecha;
    
        return `${dd}-${mesTexto}-${yyyy}`;
    };

    render() {
        const {
            show,
            mode,
            reporte,
            fechaTransito,
            loading,
            onClose,
            onChangeReporte,
            onGuardar,
            onResuelto,
        } = this.props;

        if (!show) return null;

        const esNuevo = mode === "create";
        const titulo = esNuevo ? "Crear reporte" : "Editar reporte";

        return (
            <div
                className="modal fade show reportes-backdrop"
                style={{
                    display: "block",
                    zIndex: 100,
                    background: "rgba(0,0,0,.45)",
                }}
                tabIndex="-1"
            >
<div className="modal-dialog modal-dialog-centered reportes-modal-dialog reportes-modal-dialog--form">
<div className="modal-content reportes-modal-content">
                        <div className="modal-header reportes-modal-header">
                            <h5 className="modal-title">{titulo}</h5>

                            <button
                                type="button"
                                className="btn-close"
                                onClick={onClose}
                                disabled={loading}
                            />
                        </div>

                        <div className="modal-body reportes-modal-body">
                            <div className="reportes-form-box">

                                <div className="mb-3">
                                    <div className="reportes-form-row-header">
                                        <label className="reportes-form-title mb-0">
                                            Reporte
                                        </label>

                                        <div className="reportes-fecha-inline">
                                            <span className="reportes-fecha-label">
                                                Fecha:
                                            </span>

                                            <span className="reportes-fecha-value">
                                                {this.formatoFecha(fechaTransito)}
                                            </span>
                                        </div>
                                    </div>

                                    <textarea
                                        className="form-control reportes-textarea mt-2"
                                        rows="6"
                                        value={reporte}
                                        onChange={onChangeReporte}
                                        placeholder="Escribe el reporte..."
                                        disabled={loading}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer reportes-modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary btn-fit"
                                onClick={onClose}
                                disabled={loading}
                            >
                                Cancelar
                            </button>

                            {esNuevo ? (
                                <button
                                    type="button"
                                    className="btn btn-primary btn-fit"
                                    onClick={onGuardar}
                                    disabled={loading}
                                >
                                    Crear reporte
                                </button>
                            ) : (
                                <>
                                    <button
                                        type="button"
                                        className="btn btn-success btn-fit"
                                        onClick={onResuelto}
                                        disabled={loading}
                                    >
                                        Resuelto
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-primary btn-fit"
                                        onClick={onGuardar}
                                        disabled={loading}
                                    >
                                        Guardar cambios
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SolicitudReporteModal;